import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ListFilter } from '../models/wastedMenuItems';

@Injectable({
  providedIn: 'root'
})
export class WastedMenuItemService {

  refreshList = new BehaviorSubject<boolean>(false);
  doFilter = new Subject<ListFilter>();

  constructor(private http: HttpClient) { }

  getAll(filter: ListFilter): any {
    return this.http.post(`${environment.apiUrl}/ResWasteFood/ResGetAllWasteMenuItems`, filter);
  }
  ownerGetAllWasteMenuItems(filter: ListFilter): any {
    return this.http.post(`${environment.apiUrl}/ResWasteFood/ResOwnerGetAllWasteMenuItems`, filter);
  }
  waiterGetAllWasteMenuItems(filter: ListFilter): any {
    return this.http.post(`${environment.apiUrl}/ResWasteFood/ResWaiterGetAllWasteMenuItems`, filter);
  }
  getWasteMenuItemDetails(id: any, Type: any) {
    return this.http.get(`${environment.apiUrl}/ResWasteFood/ResWasteMenuItemsById?id=${id}&Type=${Type}`);
  }
  newWasteMenuItems(data: any) {
    if (data.orderId) {
      return this.http.post(`${environment.apiUrl}/ResWasteFood/ResNewWasteOrderMenuItems`, data);
    } else {
      return this.http.post(`${environment.apiUrl}/ResWasteFood/ResNewWasteMenuItems`, data);
    }
  }
  getWasteItemsReasonList() {
    return this.http.get(`${environment.apiUrl}/ResWasteFood/ResGetWasteItemsReasonList`);
  }
  getDispositionsList() {
    return this.http.get(`${environment.apiUrl}/ResWasteFood/ResGetDispositionsList`);
  }
  getWasteItemsOrderList(RestaurantId: any) {
    return this.http.post(`${environment.apiUrl}/ResWasteFood/ResGetWasteItemsOrderList?RestaurantId=${RestaurantId}`, null);
  }
  getMenuItemForWaste(data: any) {
    return this.http.post(`${environment.apiUrl}/ResWasteFood/ResGetMenuItemForWaste`, data);
  }
  getMenuSectionsList(RestaurantId: any) {
    return this.http.get(`${environment.apiUrl}/ResWasteFood/ResGetMenuSectionsList?RestaurantId=${RestaurantId}`);
  }
  getWasteOrderItems(OrderId: any, KitchenId: number) {
    let query = `?OrderId=${OrderId}`;
    if (KitchenId) { query += `&KitchenId=${KitchenId}` };
    return this.http.post(`${environment.apiUrl}/ResWasteFood/ResGetWasteOrderItems${query}`, null);
  }
}
